<template>
  <div v-if="detail">
    <card style="margin-top: 10px">
      <description-list class="info-body" type="large">
        <description-list-item term="订单编号">
          {{ detail.orderNo }}
        </description-list-item>
        <description-list-item term="下单时间">
          {{ detail.createTime }}
        </description-list-item>
        <description-list-item term="订单状态">
          <span class="order-status order-status-wait">
            订单已确认
          </span>
        </description-list-item>
        <div v-for="(item, index) in detail.intentionDetails" :key="index">
          <div class="title">{{ index + 1 + "." + item.label + ":" }}</div>
          <div class="content">{{ item.value }}</div>
        </div>
      </description-list>
    </card>

    <div class="backIcon" @click="back">
      <Icon slot="icon" style="font-size: 24px;" type="iconkaobei" />
    </div>
  </div>
</template>

<script>
import {
  DescriptionList,
  DescriptionListItem
} from "@/components/DescriptionList";

import { statusEnum } from "@/views/order/enum";
import { getType, getZlb } from "../../utils/auth";
export default {
  components: { DescriptionList, DescriptionListItem },
  props: ['detail'],
  data() {
    return {
      isZlb: false,
      statusEnum,
      userType: ""
    };
  },
  created() {
    this.userType = getType();
    this.isZlb = getZlb();
  },
  methods: {
    back() {
      if (getType() == "user") {
        this.$router.push("/order");
      } else {
        this.$router.push("/salesman/index");
      }
    }
  }
};
</script>

<style lang="less" scoped>
.title {
  color: #525252;
  font-size: 14px;
  font-weight: bold;
}
.content {
  color: #525252;
  font-size: 14px;
  padding: 10px 0;
}
.backIcon {
  position: fixed;
  bottom: 100px;
  right: 50px;
  width: 60px;
  height: 60px;
  z-index: 10;
  border: 1px solid rgb(119, 119, 119);
  border-radius: 50px;
  text-align: center;
  line-height: 60px;
  background: #fff;
}
.orderTitleWrapper {
  margin-top: 10px;
  clear: both;
  background: #fff;
  height: 88px;
  border-bottom: 1px solid #eee;
  overflow-y: hidden;
  overflow-x: scroll;
  white-space: nowrap;
  /*display: flex;*/
  &::-webkit-scrollbar {
    display: none;
  }
}
.orderTitle {
  display: inline-block;
  font-size: 14px;
  text-align: center;
  width: 200px;
  height: 88px;
  line-height: 88px;
  overflow: hidden;
}
.orderTitleActive {
  color: #0070ff;
}
.addOil {
  color: #039df8;
  border: 1px solid #039df8;
  background: #fff;
  margin-top: 20px;
  margin-left: 20px;
}
.empty {
  height: 90px;
}
.info-body {
  padding: 20px 30px;
}
.order {
  &-status {
    &-wait {
      color: #ff3600;
    }
  }
  &-header {
    display: flex;
  }
}
.oil {
  &-list-item {
    margin-top: 20px;
    padding: 20px 30px;
    background: rgba(255, 255, 255, 1);
    /*box-shadow: 0px 3px 7px 0px rgba(186, 210, 234, 0.3);*/
    border-radius: 14px;
    display: flex;
  }
  &-logo {
    flex: none;
    margin-right: 30px;
    img {
      display: block;
      height: 140px;
      width: 140px;
    }
  }
  &-detail {
    flex: 1;
    display: flex;
    justify-content: space-between;
    flex-flow: column;
    &-title {
      font-size: 16px;
      font-family: PingFang SC;
      font-weight: 400;
      line-height: 1em;
      color: rgba(17, 17, 17, 1);
    }
    &-spec {
      font-size: 12px;
      font-family: PingFang SC;
      font-weight: 400;
      color: rgba(145, 145, 145, 1);
    }
    &-extra {
      display: flex;
      justify-content: space-between;
      line-height: 1em;
    }
    &-total {
      &-prefix {
        color: #535353;
        font-size: 12px;
      }
      color: #ff3600;
      font-size: 15px;
    }
    &-price {
      font-size: 16px;
      font-family: PingFang SC;
      font-weight: bold;
      color: #525252;
    }
    &-action {
      width: 50px;
      height: 50px;
      background: rgba(246, 246, 246, 1);
      border-radius: 50%;
      text-align: center;
      line-height: 50px;
    }
  }
}
.accountBox {
  overflow: hidden;
  clear: both;
  display: block;
  margin: 20px 0;
  padding: 20px 20px;
  background: -webkit-linear-gradient(121deg, #2f92f1, #65c8ff);
  background: -o-linear-gradient(121deg, #2f92f1, #65c8ff);
  background: -moz-linear-gradient(121deg, #2f92f1, #65c8ff);
  background: linear-gradient(121deg, #2f92f1, #65c8ff);
  border-radius: 20px;
}

.accountWrapper {
  overflow: hidden;
  text-align: left;
  color: #fff;
  margin: 20px 0;
}

.accountTitle {
  font-size: 12px;
  line-height: 40px;
}

.accountLine {
  line-height: 40px;
}

.accountName {
  float: left;
  display: block;
  font-size: 14px;
}
.oil-hetong {
  color: #777777;
  padding: 0 30px;
  font-size: 14px;
  height: 60px;
  line-height: 60px;
}
.appoint-button {
  display: flex;
  align-items: center;
  padding-bottom: 50px;
  margin-top: -50px;
}
.appoint {
  color: #039df8;
  border: 1px solid #039df8;
  background: #fff;
}
.weui-btn + .weui-btn {
  margin-top: 0;
}
.oilMain {
  background: #fff;
  font-size: 14px;
  margin: 20px 0;
}
.oilText input {
  width: 100%;
  text-align: right;
  border: none;
  background: #000;
}
.dateInput {
  width: 100%;
  text-align: right;
}
</style>
<style>
.dialog-appoint .weui-dialog {
  top: 25% !important;
  padding: 30px 0;
}
</style>
